import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Facebook } from "lucide-react";

export default function Footer() {
    return (
        <footer data-testid="footer" className="border-t border-white/5 bg-ink-950 mt-32">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
                <div className="grid md:grid-cols-12 gap-12 md:gap-8">
                    <div className="md:col-span-5">
                        <h3 className="serif text-3xl mb-4">Patrick Mathurin</h3>
                        <p className="text-bone-300 max-w-md leading-relaxed text-sm">
                            Peintre autodidacte. Portraits à l'huile et grands formats acryliques
                            d'inspiration asiatique. Chaque toile, une méditation.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div className="overline mb-5">Naviguer</div>
                        <ul className="space-y-3 text-sm text-bone-300">
                            <li><Link to="/galerie" className="link-underline hover:text-gilt">Galerie</Link></li>
                            <li><Link to="/a-propos" className="link-underline hover:text-gilt">L'artiste</Link></li>
                            <li><Link to="/expositions" className="link-underline hover:text-gilt">Expositions</Link></li>
                            <li><Link to="/contact" className="link-underline hover:text-gilt">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="overline mb-5">Suivre l'atelier</div>
                        <div className="flex items-center gap-5 text-bone-300">
                            <a data-testid="footer-facebook" href="https://www.facebook.com/" target="_blank" rel="noreferrer" aria-label="Facebook" className="hover:text-gilt transition-colors">
                                <Facebook size={18} strokeWidth={1.2} />
                            </a>
                            <a data-testid="footer-youtube" href="https://www.youtube.com/channel/UC6h331J7XzzEGl9BQrvs5yg" target="_blank" rel="noreferrer" aria-label="YouTube" className="hover:text-gilt transition-colors">
                                <Youtube size={18} strokeWidth={1.2} />
                            </a>
                            <a data-testid="footer-instagram" href="#" aria-label="Instagram" className="hover:text-gilt transition-colors">
                                <Instagram size={18} strokeWidth={1.2} />
                            </a>
                        </div>
                        <p className="text-xs text-bone-400 mt-8 leading-relaxed">
                            Créateur du groupe « Artistes Peintres Internationaux Réunis »<br />
                            616 membres · 47 pays
                        </p>
                    </div>
                </div>

                <div className="divider-gilt my-12" />

                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 text-xs text-bone-400">
                    <p>© {new Date().getFullYear()} Patrick Mathurin (Patrick Thiebaud). Tous droits réservés.</p>
                    <p className="italic-serif text-bone-300">« La peinture, comme une méditation. »</p>
                </div>
            </div>
        </footer>
    );
}
